module.exports = __webpack_public_path__ + "img/afiliate-img.bd785536.svg";